import BaseAPI from '@core/api/Platform/BaseAPI'

class Events extends BaseAPI {
  public async postVariantViewedEvent(variantId: string): Promise<void> {
    await this.api.post<string>(`event/variant/${variantId}/viewed`)
  }
}

export default Events
